import { CONTRACTUAL_FLAGS, READONLY_FLAGS, TOP_PARTNER_FLAGS } from '../../config'
import { IPartnerFlag } from '../../models/IPartnerFlag'

import { getPartnerFlagTag } from './getPartnerFlagTag'

export const isContractualsByFlag = (partnerFlags: string, partnerFlagsState: IPartnerFlag[]) => {
  const partnerFlagsNames = (partnerFlags || '').split(',')
  const newFlagsState: IPartnerFlag[] = []

  const contractualFlagsNames = (CONTRACTUAL_FLAGS || '').split(',')
  contractualFlagsNames
    .filter((el) => !!el)
    .forEach((settingFlag) => {
      let isVisible = true

      const tag = getPartnerFlagTag(settingFlag)

      const foundFlags = newFlagsState.filter((el) => el.name === settingFlag)
      if (!foundFlags.length) {
        const isPartnerFlag = partnerFlagsNames.includes(settingFlag)
        const isReadonly = READONLY_FLAGS.indexOf(settingFlag) >= 0
        const isTopPartner = TOP_PARTNER_FLAGS.indexOf(settingFlag) >= 0

        const flagFromSettings = partnerFlagsState.some(
          (el) => el.name === settingFlag && el.isEnabled
        )
        // Get Flag state from settings (if settings exist)
        let isSettingPresent = false
        let isFlagManuallyEnabled = false
        if (flagFromSettings !== undefined && flagFromSettings !== null) {
          isSettingPresent = true
          isFlagManuallyEnabled = !!flagFromSettings
        }

        // Flags enabled by default for TopPartners and PartnerFlags (if no settings)
        const isForceEnabled = isPartnerFlag && (isTopPartner || !isSettingPresent)
        const isFlagEnabled = isForceEnabled ? true : isFlagManuallyEnabled

        // Force visibility for Partner level flag
        if (isPartnerFlag) {
          isVisible = true
        }

        newFlagsState.push({
          name: settingFlag,
          tag,
          isPartnerFlag,
          isReadonly,
          isTopPartner,
          isEnabled: isFlagEnabled,
          isVisible,
          isSkipTransactional: false,

          disablingUser: '',
          disablingDate: '',
          disablingComment: '',
        })
      }
    })

  return newFlagsState.some((el) => el.isEnabled)
}
